import React, { useEffect } from "react";
import { Container, Row, Col, Card, CardHeader, Form, FormGroup, Label, Input, FormFeedback, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader, Button } from '@/Components/ui';
;
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Toaster } from 'react-hot-toast';
import { API_SUPPLY_ORDER_LIST, getDataFromUrl, BACKEND_HOST, API } from "../../../api";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { dialogService } from "@/utils/dialogService";
const clearSelectedOptions = (itemClass = "checkbox-item", headId = "checkBoxAll") => {
    const ele = document.querySelectorAll(`.${itemClass}:checked`);
    const checkall = document.getElementById(headId);
    ele.forEach((element) => {
        element.checked = false;
    });
    checkall.checked = false;
};
const getCheckedRecords = (itemClass = "checkbox-item", data = []) => {
    const ele = document.querySelectorAll(`.${itemClass}:checked`);
    let checkedItem = [];
    try {
        ele.forEach((element) => {
            let tmpArr = data.filter((item) => item.id.toString() === element.value.toString());
            let obj = tmpArr[0];
            checkedItem.push(obj);
        });
    }
    catch (error) {
        console.log(error);
    }
    return checkedItem;
};
const toggleCheckAll = (itemClass = "checkbox-item", headId = "checkBoxAll") => {
    const checkall = document.getElementById(headId);
    const ele = document.querySelectorAll(`.${itemClass}`);
    if (checkall.checked) {
        ele.forEach((ele) => {
            ele.checked = true;
        });
    }
    else {
        ele.forEach((ele) => {
            ele.checked = false;
        });
    }
};
const SupplyAdmin = () => {
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const [dataQuery, setDataQuery] = React.useState({});
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => { console.log(e); });
    };
    React.useEffect(() => {
        if (!previous && !next) {
            getDataFromUrl(API_SUPPLY_ORDER_LIST)
                .then((data) => {
                // console.log(data);
                setData(data.results);
                setPrevious(data.previous);
                setNext(data.next);
                setCount(data.count);
            })
                .catch((e) => { console.log(e); });
        }
    }, []);
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [stateChangeModal, setStateChangeModal] = React.useState(false);
    const togStateChangeModal = () => setStateChangeModal(!stateChangeModal);
    const [deliveryChangeModal, setDeliveryChangeModal] = React.useState(false);
    const togDeliveryChangeModal = () => setDeliveryChangeModal(!deliveryChangeModal);
    const handleCancelOrder = async (orderId) => {
        if (await dialogService.confirm("정말 취소하시겠습니까?") === false)
            return;
        API.post(`${BACKEND_HOST}/supply/order-cancel/`, {
            order_id: orderId,
            partial_cancels: null,
            cancel_reason: "본사관리자취소",
            //   partial_cancels: [
            // 	{ id: item_id }
            //   ]
        })
            .then((res) => {
            console.log("order-cancel", res);
            if (res.status === 200) {
                console.log("삭제 성공");
                onRequestData(API_SUPPLY_ORDER_LIST);
            }
            else {
                console.log("삭제 실패");
            }
        })
            .catch((e) => console.log(e));
    };
    const handlePostDelivery = async ({ orderId, itemIds, recipient, address, memo, invoice_num, invoice_info }) => {
        const response = await API.post(`${BACKEND_HOST}/supply/delivery/`, {
            order_id: orderId,
            partial_deliveries: itemIds,
            recipient: recipient,
            address: address,
            memo: memo,
            invoice_num: invoice_num,
            invoice_info: invoice_info,
        });
        try {
            if (response.status === 200) {
                console.log("배송 성공");
                onRequestData(API_SUPPLY_ORDER_LIST);
            }
            else {
                console.log("배송 실패");
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    const handlePutDelivery = async ({ delivery_id, recipient, address, memo, invoice_num, invoice_info, state }) => {
        const response = await API.put(`${BACKEND_HOST}/supply/delivery/`, {
            delivery_id: delivery_id,
            recipient: recipient,
            address: address,
            memo: memo,
            invoice_num: invoice_num,
            invoice_info: invoice_info,
            state: state,
        });
        try {
            if (response.status === 200) {
                console.log("배송 성공");
                onRequestData(API_SUPPLY_ORDER_LIST);
            }
            else {
                console.log("배송 실패");
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    const columns = React.useMemo(() => [
        {
            Header: <input type="checkbox" className="form-check-input" id="checkBoxAll" onClick={() => toggleCheckAll("checkbox-item", "checkBoxAll")}/>,
            Cell: (cellProps) => {
                return <input type="checkbox" className="form-check-input checkbox-item" id={`checkBox-${cellProps.row.original.id}`} value={cellProps.row.original.id}/>;
            },
            id: '#',
        },
        {
            Header: 'ID',
            accessor: 'id',
            id: 'id',
        },
        {
            Header: '지점',
            accessor: 'subdomain',
            id: 'subdomain',
            Cell: (cellProps) => {
                const supply_items = cellProps.row.original["supply_items"];
                return <span>{supply_items[0]["sitename"]}</span>;
            }
        },
        {
            Header: '주문자',
            accessor: 'user_phone_num',
            id: 'user_phone_num',
            Cell: (cellProps) => {
                return <span>{cellProps.row.original["username"]}({cellProps.row.original["user_phone_num"]})</span>;
            }
        },
        {
            Header: '상품명',
            accessor: 'supply_items',
            id: 'supply_items',
            Cell: (cellProps) => {
                const supply_items = cellProps.row.original["supply_items"];
                const _length = supply_items.length;
                return <span>{supply_items[0]["supply_product"]["name"]} {_length > 1 ? `(외 ${_length - 1})` : ""}</span>;
            }
        },
        {
            Header: '가격',
            accessor: 'amount',
            id: 'amount',
            Cell: (cellProps) => {
                const supply_items = cellProps.row.original["supply_items"];
                const _length = supply_items.length;
                const sum_amount = supply_items.reduce((accumulator, currentValue) => accumulator + currentValue["supply_product"]["price"] * currentValue["quantity"], 0);
                return <span>
					{new Intl.NumberFormat().format(sum_amount)}
				</span>;
            }
        },
        {
            Header: '상태',
            accessor: 'state',
            id: 'state',
            Cell: (cellProps) => {
                const canceled = ["취소완료", "부분취소"].includes(cellProps.row.original["state"]);
                const delivery = cellProps.row.original["delivery"];
                if (canceled)
                    return <span className="text-danger">{cellProps.row.original["state"]}</span>;
                if (!delivery)
                    return <span>결제완료</span>;
                return (<Button onClick={() => {
                        setCheckedRecords([cellProps.row.original]);
                        togDeliveryChangeModal();
                    }} color="soft-primary" size="sm">배송관리</Button>);
            }
        },
        // {
        //     Header: '수량',
        //     accessor: 'quantity',
        //     id: 'quantity',
        // },
        {
            Header: '주문일시',
            accessor: 'order_date',
            id: 'order_date',
            Cell: (cellProps) => {
                return <span>{cellProps.row.original["order_date"] !== "-" ? moment(cellProps.row.original["order_date"]).format("YYYY-MM-DD HH:mm") : ""}</span>;
            }
        },
        {
            Header: 'Actions',
            accessor: 'Actions',
            id: '',
            Cell: (cellProps) => {
                const canceled = ["취소완료", "부분취소"].includes(cellProps.row.original["state"]);
                const delivery = cellProps.row.original["delivery"];
                return (<div className="d-flex gap-2">
						{!canceled ? <>
							{!delivery ? <Button onClick={() => {
                                setCheckedRecords([cellProps.row.original]);
                                togStateChangeModal();
                            }} color="soft-primary" size="sm">배송시작</Button> : null}
							<div className="remove">
								<div className="text-danger" style={{ cursor: "pointer" }} onClick={() => handleCancelOrder(cellProps.row.original.id)}>
									<i className="ri-delete-bin-5-fill fs-16"></i>
								</div>
							</div>
						</> : null}
					</div>);
            }
        },
    ], []);
    return (<React.Fragment>
			<div className="page-content">

				<Container fluid>
					<BreadCrumb title="지점발주목록" pageTitle="발주"/>
					<Row>
						<Col lg={12}>
							<Card id="customerList">
								<CardHeader className="border-0">
									<Row className="g-4 align-items-center">
										<div className="col-sm">
											<div>
												<h5 className="card-title mb-0">지점 발주 목록</h5>
											</div>
										</div>
										<div className="col-sm-auto">
											<div className="hstack gap-2">

												<span style={{ padding: "4px" }}></span>

												{/* <Button
            onClick={() => { changeCheckedRecords(); togStateChangeModal(); setFocusState(0) }}
         color="soft-secondary" className="me-1">사용처리</Button>
        <Button
            onClick={() => { changeCheckedRecords(); togStateChangeModal(); setFocusState(1) }}
         color="soft-warning" className="me-1">사용취소</Button>
        <Button
            onClick={() => { changeCheckedRecords(); togDeleteModal(); }}
         color="soft-danger" className="me-1"><i className="ri-delete-bin-2-line"></i></Button> */}
											</div>
										</div>
									</Row>
								</CardHeader>

								<div className="card-body pt-0 px-2">
									<div>
										<React.Fragment>
											<ServerPaginatedTable url={API_SUPPLY_ORDER_LIST} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} onChangeQuery={setDataQuery} categories={[
        // { id: 0, title: "전체", search: "", icon: "ri-store-2-fill" },
        // { id: 1, title: "예약완료", search: "", icon: "ri-checkbox-circle-line" },
        // { id: 2, title: "입금대기", search: "", icon: "ri-more-fill" },
        // { id: 3, title: "취소완료", search: "", icon: "ri-arrow-left-right-fill" },
        ]}/>
										</React.Fragment>
									</div>
									<Toaster position="top-center"/>
								</div>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>

			{/* Delivery Modal */}
			<DeliveryAddModal key={checkedRecords[0] ? "DeliveryAdd" + checkedRecords[0]["id"] : "DeliveryAdd"} isOpen={stateChangeModal} toggle={togStateChangeModal} checkedRecords={checkedRecords} onDeliveryChange={(selectedItem, inputData) => {
            const _body = {
                orderId: selectedItem[0]["order_id"],
                itemIds: selectedItem.map((item) => item["id"]),
                // recipient: "",
                // address: "",
                // memo: "",
                ...inputData,
                invoice_num: "",
                invoice_info: "",
            };
            console.log("onDeliveryChange _body", _body);
            handlePostDelivery(_body).finally(() => {
                togStateChangeModal();
            });
        }}/>

			<DeliveryEditModal key={checkedRecords[0] ? "DeliveryEdit" + checkedRecords[0]["id"] : "DeliveryEdit"} isOpen={deliveryChangeModal} toggle={togDeliveryChangeModal} checkedRecords={checkedRecords} deliveryItem={checkedRecords[0] ? checkedRecords[0]["delivery"] : null} onDeliveryChange={(selectedItem, inputData) => {
            const _body = {
                delivery_id: checkedRecords[0]["delivery"]["id"],
                ...inputData,
            };
            handlePutDelivery(_body).finally(() => {
                togDeliveryChangeModal();
            });
        }}/>

		</React.Fragment>);
};
export default SupplyAdmin;
const DeliveryAddModal = ({ isOpen, toggle, checkedRecords, onDeliveryChange }) => {
    const [selectedItem, setSelectedItem] = React.useState([]);
    const [recipient, setRecipient] = React.useState("");
    const [address, setAddress] = React.useState("");
    const [memo, setMemo] = React.useState("");
    useEffect(() => {
        console.log("checkedRecords", checkedRecords);
        if (checkedRecords.length > 0) {
            setSelectedItem(checkedRecords[0]["supply_items"]);
        }
    }, [checkedRecords]);
    return (<Modal id="topmodal" isOpen={isOpen} onClose={toggle}>
			<ModalHeader className="modal-title" id="myModalLabel" toggle={toggle}>
				배송관리
			</ModalHeader>
			<ModalBody className="text-center p-5">
				<div className="form-group mb-3">
					<div className="d-flex flex-row mb-1">
						<div className="w-25">
							<label className="form-label" htmlFor="modal-recipient">수령인</label>
						</div>
						<div className="w-75">
							<input type="text" className="form-control" id="modal-recipient" value={recipient} onChange={(e) => setRecipient(e.target.value)}/>
						</div>
					</div>
					<div className="d-flex flex-row mb-1">
						<div className="w-25">
							<label className="form-label" htmlFor="modal-address">주소</label>
						</div>
						<div className="w-75">
							<input type="text" className="form-control" id="modal-address" value={address} onChange={(e) => setAddress(e.target.value)}/>
						</div>
					</div>
					<div className="d-flex flex-row mb-1">
						<div className="w-25">
							<label className="form-label" htmlFor="modal-memo">메모</label>
						</div>
						<div className="w-75">
							<input type="text" className="form-control" id="modal-memo" value={memo} onChange={(e) => setMemo(e.target.value)}/>
						</div>
					</div>
				</div>
				<div className="d-flex flex-row">
					<input type="checkbox" className="modal-checkbox-item" id="modal-checkbox-all" value="all" checked={checkedRecords.length > 0 ? selectedItem.length === checkedRecords[0]["supply_items"].length : false} disabled onChange={(e) => {
            if (e.target.checked) {
                setSelectedItem(checkedRecords[0]["supply_items"]);
            }
            else {
                setSelectedItem([]);
            }
        }}/>
					<label className="form-label" htmlFor="modal-checkbox-all">
						<span>&nbsp;</span>
						<span className="fw-bold">전체선택</span>
					</label>
				</div>

				{checkedRecords.length > 0 ? <>
					{checkedRecords[0]["supply_items"]
                .filter((item) => !item["delivery"])
                .map((item, index) => {
                return (<div key={index}>
									<div className="d-flex flex-row mb-2 gap-2 justify-content-start align-items-center">
										<div className="">
											<input type="checkbox" className="modal-checkbox-item" id={`modal-checkbox-${item["id"]}`} value={item["id"]} checked={selectedItem.filter((item_) => item_["id"] === item["id"]).length > 0} disabled onChange={(e) => {
                        if (e.target.checked) {
                            setSelectedItem([...selectedItem, item]);
                        }
                        else {
                            setSelectedItem(selectedItem.filter((item_) => item_["id"] !== item["id"]));
                        }
                    }}/>
										</div>
										<div>
											<img src={`${item["supply_product"]["thumbnail"]}`} alt="" width="50" height="50"/>
										</div>
										<div className="">
											<label className="form-label" htmlFor={`modal-checkbox-${item["id"]}`}>
												<span className="fw-bold">{item["supply_product"]["name"]}</span>
												<span>&nbsp;</span>
												<span className="fw-bold">{item["quantity"]}개</span>
												<span>&nbsp;</span>
												<span className="fw-bold">{item["supply_product"]["price"]}원</span>
												<span>&nbsp;</span>
												<span className="fw-bold">{item["supply_product"]["price"] * item["quantity"]}원</span>
											</label>
										</div>
									</div>
								</div>);
            })}
				</> : null}
				<div className="mt-3"></div>

				<div className="hstack gap-2 justify-content-center">
					<Button onClick={(e) => {
            e.preventDefault();
            onDeliveryChange(selectedItem, {
                recipient: recipient,
                address: address,
                memo: memo,
            });
        }} disabled={checkedRecords.length === 0} color="danger">배송시작하기</Button>
				</div>
			</ModalBody>
		</Modal>);
};
const DeliveryEditModal = ({ isOpen, toggle, checkedRecords, deliveryItem, onDeliveryChange }) => {
    const [selectedItem, setSelectedItem] = React.useState([]);
    const [state, setState] = React.useState("");
    const [recipient, setRecipient] = React.useState("");
    const [address, setAddress] = React.useState("");
    const [memo, setMemo] = React.useState("");
    const [invoice_num, setInvoiceNum] = React.useState("");
    const [invoice_info, setInvoiceInfo] = React.useState("");
    const [supplyItems, setSupplyItems] = React.useState([]);
    useEffect(() => {
        console.log("deliveryItem", deliveryItem);
        if (deliveryItem) {
            setRecipient(deliveryItem["recipient"]);
            setAddress(deliveryItem["address"]);
            setMemo(deliveryItem["memo"]);
            setInvoiceNum(deliveryItem["invoice_num"]);
            setInvoiceInfo(deliveryItem["invoice_info"]);
            setState(deliveryItem["state"]);
            setSupplyItems(deliveryItem["supply_items"]);
        }
    }, [deliveryItem]);
    return (<Modal id="topmodal" isOpen={isOpen} onClose={toggle}>
			<ModalHeader className="modal-title" id="myModalLabel" toggle={toggle}>
				배송관리
			</ModalHeader>
			<ModalBody className="text-center p-5">
				<div className="form-group mb-3">
					{deliveryItem?.subdomain ? <div className="d-flex flex-row mb-1">
						<div className="w-25">
							<label className="form-label">지점</label>
						</div>
						<div className="w-75">
							<span>{deliveryItem.subdomain}</span>
						</div>
					</div> : null}
					<div className="d-flex flex-row mb-1">
						<div className="w-25">
							<label className="form-label" htmlFor="modal-recipient">수령인</label>
						</div>
						<div className="w-75">
							<input type="text" className="form-control" id="modal-recipient" value={recipient} onChange={(e) => setRecipient(e.target.value)}/>
						</div>
					</div>
					<div className="d-flex flex-row mb-1">
						<div className="w-25">
							<label className="form-label" htmlFor="modal-address">주소</label>
						</div>
						<div className="w-75">
							<input type="text" className="form-control" id="modal-address" value={address} onChange={(e) => setAddress(e.target.value)}/>
						</div>
					</div>
					<div className="d-flex flex-row mb-1">
						<div className="w-25">
							<label className="form-label" htmlFor="modal-memo">메모</label>
						</div>
						<div className="w-75">
							<input type="text" className="form-control" id="modal-memo" value={memo} onChange={(e) => setMemo(e.target.value)}/>
						</div>
					</div>

					<div className="d-flex flex-row mb-1">
						<div className="w-25">
							<label className="form-label" htmlFor="modal-invoice-num">송장번호</label>
						</div>
						<div className="w-75">
							<input type="text" className="form-control" id="modal-invoice-num" value={invoice_num} onChange={(e) => setInvoiceNum(e.target.value)}/>
						</div>
					</div>
					<div className="d-flex flex-row mb-1">
						<div className="w-25">
							<label className="form-label" htmlFor="modal-invoice-info">송장정보</label>
						</div>
						<div className="w-75">
							<input type="text" className="form-control" id="modal-invoice-info" value={invoice_info} onChange={(e) => setInvoiceInfo(e.target.value)}/>
						</div>
					</div>
					<div className="d-flex flex-row mb-1">
						<div className="w-25">
							<label className="form-label" htmlFor="modal-state">상태</label>
						</div>
						<div className="w-75">
							<select className="form-select" id="modal-state" value={state} onChange={(e) => setState(e.target.value)}>
								<option value="주문접수">주문접수</option>
								<option value="배송준비중">배송준비중</option>
								<option value="배송중">배송중</option>
								<option value="배송완료">배송완료</option>
								<option value="취소요청">취소요청</option>
								<option value="취소완료">취소완료</option>
							</select>
						</div>
					</div>
				</div>
				{/* <div className="d-flex flex-row">
            <input type="checkbox" className="modal-checkbox-item" id="modal-checkbox-all" value="all"
                onChange={(e) => {

                }} />
            <label className="form-label" htmlFor="modal-checkbox-all">
                <span>&nbsp;</span>
                <span className="fw-bold">전체선택</span>
            </label>
        </div> */}
				<div className="mt-3"></div>

				<div className="">
					{supplyItems ? supplyItems.map((item, index) => {
            return (<div key={index}>
								<div className="d-flex flex-row mb-2 gap-2 justify-content-start align-items-center">
									<div className="">
										{/* <input type="checkbox" className="modal-checkbox-item" id={`modal-checkbox-${item["id"]}`} value={item["id"]}
                    checked={selectedItem.filter((item_) => item_["id"] === item["id"]).length > 0}
                    onChange={(e) => {
                        if (e.target.checked) {
                            setSelectedItem([...selectedItem, item]);
                        } else {
                            setSelectedItem(selectedItem.filter((item_) => item_["id"] !== item["id"]));
                        }
                    }} /> */}
									</div>
									<div>
										<img src={`${item["supply_product"]["thumbnail"]}`} alt="" width="50" height="50"/>
									</div>
									<div className="">
										<label className="form-label" htmlFor={`modal-checkbox-${item["id"]}`}>
											<span className="fw-bold">{item["supply_product"]["name"]}</span>
											<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
											<span className="fw-bold">{item["supply_product"]["price"]}원</span>
											<span>&nbsp;</span>
											<span className="fw-bold">{item["quantity"]}개</span>
											<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
											<span className="fw-bold">{item["supply_product"]["price"] * item["quantity"]}원</span>
										</label>
									</div>
								</div>
							</div>);
        }) : null}
				</div>


				<div className="mt-3"></div>

				<div className="hstack gap-2 justify-content-center">
					<Button onClick={(e) => {
            e.preventDefault();
            onDeliveryChange(selectedItem, {
                recipient: recipient,
                address: address,
                memo: memo,
                invoice_num: invoice_num,
                invoice_info: invoice_info,
                state: state,
            });
        }} color="danger">배송상태 업데이트</Button>
				</div>
			</ModalBody>
		</Modal>);
};
